import React from "react";

interface InfluencerIconProps {
  width?: number;
  height?: number;
  fill?: string;
}

export const InfluencerIcon: React.FC<InfluencerIconProps> = ({
  width = 20,
  height = 14,
  fill = "#718392",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4999 0.333374C13.384 0.333374 14.2318 0.684563 14.8569 1.30968C15.4821 1.93481 15.8333 2.78265 15.8333 3.66671C15.8333 4.55076 15.4821 5.39861 14.8569 6.02373C14.2318 6.64885 13.384 7.00004 12.4999 7.00004C11.6159 7.00004 10.768 6.64885 10.1429 6.02373C9.51778 5.39861 9.16659 4.55076 9.16659 3.66671C9.16659 2.78265 9.51778 1.93481 10.1429 1.30968C10.768 0.684563 11.6159 0.333374 12.4999 0.333374ZM12.4999 1.91671C12.0358 1.91671 11.5907 2.10108 11.2625 2.42927C10.9343 2.75746 10.7499 3.20258 10.7499 3.66671C10.7499 4.13084 10.9343 4.57596 11.2625 4.90414C11.5907 5.23233 12.0358 5.41671 12.4999 5.41671C12.964 5.41671 13.4092 5.23233 13.7374 4.90414C14.0655 4.57596 14.2499 4.13084 14.2499 3.66671C14.2499 3.20258 14.0655 2.75746 13.7374 2.42927C13.4092 2.10108 12.964 1.91671 12.4999 1.91671ZM12.4999 7.83337C14.7249 7.83337 19.1666 8.94171 19.1666 11.1667V13.6667H5.83325V11.1667C5.83325 8.94171 10.2749 7.83337 12.4999 7.83337ZM12.4999 9.41671C9.99992 9.41671 7.41659 10.6334 7.41659 11.1667V12.0834H17.5833V11.1667C17.5833 10.6334 14.9749 9.41671 12.4999 9.41671ZM4.16659 8.06671L2.08325 9.30837L2.64992 6.96671L0.833252 5.40004L3.22492 5.19171L4.16659 2.99171L5.09159 5.19171L7.49992 5.40004L5.66659 6.96671L6.20825 9.30837L4.16659 8.06671Z"
        fill={fill}
      />
    </svg>
  );
};
